import { AppRecordValidateUpdate } from 'routes';
import { sharedValidateUsEntrySummary } from '../sharedValidateUsEntrySummary';

const validateUsPostSummaryCorrection: AppRecordValidateUpdate = ({
  input,
  currentUser,
}) => {
  const { additionalErrors, validateFields } = sharedValidateUsEntrySummary({
    input,
    currentUser,
  });
  validateFields.push(['entryNumber'], ['headerReasons'], ['explanation']);
  return {
    additionalErrors,
    validateFields,
  };
};

export default validateUsPostSummaryCorrection;
